import { render, staticRenderFns } from "./UserBookingsDataTable.vue?vue&type=template&id=764ac79e"
import script from "./UserBookingsDataTable.vue?vue&type=script&lang=js"
export * from "./UserBookingsDataTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports